import db from 'src/lib/dexie-db/db';
import { NodeType } from 'src/modules/exam-preparation/graphql/common/types/node';
import { getSafeData } from './utils';
const SubjectAPIs = {
    async getList(userID, examLevelID, type, pagination = { offset: 0 }) {
        const { offset = 0, limit = 20 } = pagination;
        let query = db.qnaNode
            .where('ancestors')
            .equals(examLevelID)
            .and(node => node.type === type &&
            !node.deleted);
        if (pagination) {
            query = query
                .offset(offset)
                .limit(limit);
        }
        const subjects = await query.toArray();
        // Sort by sequence
        subjects.sort((a, b) => (a.data.sequence ?? 0) - (b.data.sequence ?? 0));
        const totalCount = await db.qnaNode
            .where('ancestors')
            .equals(examLevelID)
            .and(node => node.type === type &&
            !node.deleted)
            .count();
        return {
            list: subjects.map(getSafeData),
            totalCount,
        };
    },
    async getByID(userID, subjectID) {
        const subject = await db.qnaNode.get(subjectID);
        if (!subject ||
            ![NodeType.WRITTEN_SUBJECT, NodeType.ORALS_SUBJECT].includes(subject.type) ||
            subject.deleted) {
            throw new Error('Subject not found');
        }
        return getSafeData(subject);
    },
    async getAttributes(userID, subjectID) {
        const subject = await this.getByID(userID, subjectID);
        // Count total questions
        const totalQuestions = await db.qnaNode
            .where('ancestors')
            .equals(subjectID)
            .and(node => {
            const isQuestionType = subject.type === NodeType.WRITTEN_SUBJECT
                ? node.type === NodeType.WRITTEN_QUESTION
                : node.type === NodeType.ORALS_QUESTION;
            return isQuestionType && !node.deleted;
        })
            .count();
        // Count answered questions
        const answeredQuestions = await db.qnaNode
            .where('ancestors')
            .equals(subjectID)
            .and(node => {
            const isQuestionType = subject.type === NodeType.WRITTEN_SUBJECT
                ? node.type === NodeType.WRITTEN_QUESTION
                : node.type === NodeType.ORALS_QUESTION;
            return isQuestionType && !node.deleted && node.attributes?.answered === true;
        })
            .count();
        return {
            totalQuestionCount: totalQuestions,
            answeredQuestionCount: answeredQuestions,
        };
    },
    getSafeData,
};
export default SubjectAPIs;
